import * as React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, InjectedFormProps, reduxForm} from "redux-form";
import {DatePickerField, RenderAreaField, SelectField, Validators} from "components/Layout/Form/Fields/_Fields";
import {compose} from "redux";
import * as Dictionary from "Models/Dictionary";

type ConnectedProps = {
    t?: Function;
};

type Props = {
    dateInputName: string;
    dateOnly?: boolean;
};

type State = {};

class TurnOffCarForm extends React.Component<ConnectedProps & InjectedFormProps & Props, State> {
    constructor(props: ConnectedProps & InjectedFormProps & Props) {
        super(props);
    }

    public render() {
        const {pristine, submitting, t, handleSubmit, dateOnly, dateInputName} = this.props;
        const turnOffReasonOptions = Dictionary.GenerateList(Dictionary.TurnOffReasonArray, 'dictionary');

        return (
            <form className="form date-padding">
                <Field
                    name={dateInputName}
                    component={DatePickerField}
                    allowPastDates={true}
                    type="text"
                    placeholder={t('carDetails:turnOffDate')}
                    label={t('carDetails:turnOffDate')}
                    validate={[Validators.required]}
                    dateRangePlaceholder={t('dateRangePlaceholder')}
                />
                {!dateOnly && <>
                    <Field
                        name="turnOffReason"
                        component={SelectField}
                        options={turnOffReasonOptions}
                        type="text"
                        placeholder={t('turnOffReason')}
                        label={t('turnOffReason')}
                        validate={[Validators.required]}
                    />
                    <Field
                        name="turnOffNote"
                        component={RenderAreaField}
                        type="text"
                        placeholder={t('turnOffNote')}
                        label={t('turnOffNote')}
                        validate={[Validators.required]}
                    />
                </>}
            </form>
        );
    }
}

export default compose(
    withTranslation(['forms', 'errors', 'carDetails']),
    reduxForm({
        form: 'ChangeDateForm',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(TurnOffCarForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/CarsManagement/TurnOffCarForm.tsx